<template>
   <div class="full-height">
        <q-dialog persistent v-model="renderModal" full-height>
          <q-layout view="lHh Lpr lFf" container full-height class="bg-white modal-large jtSearchOwnershipChangeContainer">
            <q-header class="bg-primary">
              <q-toolbar>
                <q-toolbar-title><translate>OWNERSHIP_CHANGE</translate></q-toolbar-title>
                <q-btn @click="clearOwnershipChange" flat round dense icon="close" />
              </q-toolbar>
            </q-header>
            <q-footer class="bg-white">
                <div class="row full-width q-col-gutter-lg justify-center q-py-lg">
                    <div v-if="pageCount === 0" key="cancel" class="col-lg-2 col-md-3">
                        <q-btn class="full-width cancel-btn"  @click="clearOwnershipChange">
                            <translate>CANCEL</translate>
                        </q-btn>
                    </div>
                    <div v-else key="return" class="col-lg-2 col-md-3">
                        <q-btn class="full-width cancel-btn"  @click="$refs.stepper.previous()">
                            <translate>BACK</translate>
                        </q-btn>
                    </div>
                    <div v-if="pageCount === 3" key="save" class="col-lg-2 col-md-3">
                        <q-btn class="full-width" color="positive" @click="saveOwnershipChange">
                            <translate>SAVE</translate>
                        </q-btn>
                    </div>
                    <div v-else key="continue" class="col-lg-2 col-md-3">
                        <q-btn class="full-width" color="positive" @click="continuePage">
                            <translate>CONTINUE</translate>
                        </q-btn>
                    </div>
                </div>
            </q-footer>
            <q-page-container class="full-height">
                <q-stepper animated v-model="pageCount" ref="stepper" color="primary">
                    <q-step :name="0" :title="this.$gettext('OWNERSHIP_CHANGE_STEPPER_OWNER_OCCUPIER')" :done="pageCount > 0" icon="file_copy">
                        <jt-dynamic-form
                            ref="dynamicForm"
                            :inputs="ownershipChangeForm.inputs"
                            :relacionamentos="ownershipChangeForm.relacionamentos"
                            :model="ownershipChangeForm.dadosForm"
                            :interface="ownershipChangeForm.nmInterface"
                            form-class="form"
                            class="q-pr-lg q-pl-lg jtSearchOwnershipChangeForm"
                            @search-found="selections"
                        />
                    </q-step>
                    <q-step :name="1" :title="this.$gettext('OWNERSHIP_CHANGE_STEPPER_FILES')" :done="pageCount > 1" icon="attach_file">
                        <div  v-for="(item, index) in listFormFiles"
                                :key="index"
                                >
                            <div class="full-width row no-spacing justify-between">
                                <span class="col-10 self-center q-pl-lg text-bold">
                                    <translate v-if="index != 0">{{ titleTopBar }}</translate>
                                </span>
                                <q-btn class="q-py-xs q-mx-md"
                                    :disabled="index === 0 && Object.keys(item).length === 1"
                                    flat
                                    icon="close"
                                    @click="dropItemFile(index)">
                                    <q-tooltip>
                                    <translate>REMOVE</translate>
                                    </q-tooltip>
                                </q-btn>
                            </div>
                            <jt-dynamic-form
                                :ref="`itemForm-${index}`"
                                :inputs="ownershipChangeFilesForm.inputs"
                                :interface="ownershipChangeFilesForm.nmInterface"
                                :relacionamentos="ownershipChangeFilesForm.relacionamentos"
                                :model="item"
                                form-class="form"
                                class="q-pr-sm q-pl-sm jtSearchOwnershipChangeFormSummaryFiles" />
                        </div>
                        <div class="text-center q-px-md">
                            <q-btn class="bg-secondary text-white full-height self-center"
                                icon="add"
                                @click="addItemFile">
                                <translate>ADD_FILE</translate>
                            </q-btn>
                        </div>
                    </q-step>
                    <q-step :name="2" :title="this.$gettext('OWNERSHIP_CHANGE_DATES')" :done="pageCount > 2" icon="date_range">
                        <jt-dynamic-form v-if="pageCount == 2"
                            ref="dynamicForm"
                            :inputs="ownershipChangeDatesForm.inputs"
                            :relacionamentos="ownershipChangeDatesForm.relacionamentos"
                            :model="ownershipChangeDatesForm.dadosForm"
                            :interface="ownershipChangeDatesForm.nmInterface"
                            form-class="form"
                            class="q-pa-lg jtSearchOwnershipChangeFormSummary"
                        />
                    </q-step>
                    <q-step :name="3" :title="this.$gettext('SUMMARY')" :done="pageCount > 3" icon="description">
                        <jt-dynamic-form
                            ref="dynamicForm"
                            :inputs="partitionElementsInputsSummary[1]"
                            :relacionamentos="ownershipChangeForm.relacionamentos"
                            :model="ownershipChangeForm.dadosForm"
                            :interface="nmInterfaceSummary"
                            form-class="form"
                            class="q-pa-lg jtSearchOwnershipChangeFormSummary"
                            @search-found="selections"
                        />
                        <div v-for="(item, index) in listFormFiles" :key="index">
                            <div class="full-width row no-spacing justify-between">
                                <span class="col-10 self-center q-pl-lg text-bold">
                                    <translate v-if="index != 0">{{ titleTopBar }}</translate>
                                </span>
                            </div>
                            <jt-dynamic-form
                                :ref="`itemForm-${index}`"
                                :inputs="partitionElementsInputsSummary[0]"
                                :interface="ownershipChangeFilesForm.nmInterface"
                                :relacionamentos="ownershipChangeFilesForm.relacionamentos"
                                :model="item"
                                form-class="form"
                                class="q-pa-sm jtSearchOwnershipChangeFormSummaryFiles" />
                        </div>
                        <div class="q-pa-lg"><strong>{{dateRegisterType}}: {{ dateText }}</strong></div>
                    </q-step>
                </q-stepper>
            </q-page-container>
        </q-layout>
    </q-dialog>
</div>
</template>

<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { InputMixin } from 'jtech-webcomps/src/mixins'
import { JtDynamicForm } from 'jtech-webcomps'
import { repository, messageBox } from 'jtech'
import { QBtn, QInput, QFooter, QPageContainer } from 'quasar'

  @Component({
    name: 'JtSearchOwnershipChange',
    mixins: [InputMixin],
    components: { JtDynamicForm, QBtn, QInput, QFooter, QPageContainer },
    props: {
      ownershipChangeForm: {
        type: Object
      },
      ownershipChangeFilesForm: {
        type: Object
      },
      ownershipChangeDatesForm: {
        type: Object
      }
    }
  })
class JtSearchOwnershipChangeModal extends Vue {
    renderModal = true;
    listFormFiles = []
    pageCount = 0
    dateRegisterTypeText = { 50020001: this.$gettext('CURRENT_OWNER_CHANGE'), 50020002: this.$gettext('OLD_OWNER_CHANGE') }
    ownerFieldMemory = ''
    occupierFieldMemory = ''
    ownershipChangeSummaryForm = {}
    nmInterfaceSummary = 'ownershipChange.summary'
    created () {
      if (this.value) this.fetchData('id')
    }

    async mounted () {
      this.addItemFile()
      await this.getSummaryForm()
      this.fillMemoryFields()
    }

    splitClients () {
      if (this.ownershipChangeForm.dadosForm.consumerUnitClients) {
        return this.ownershipChangeForm.dadosForm.consumerUnitClients.reduce(function (result, client, i) {
          if (client.clientUnitType == 20420001) {
            result[0].push(client)
          } else if (client.clientUnitType == 20420002) {
            result[1].push(client)
          } else {
            result[2].push(client)
          }
          return result
        }, [[], [], []]
        )
      } else {
        return [[], [], []]
      }
    }

    async getSummaryForm () {
      const form = await repository.resolve(this.nmInterfaceSummary)
      this.ownershipChangeSummaryForm = form[0]
    }

    fillMemoryFields () {
      this.ownerFieldMemory = this.ownershipChangeForm.dadosForm.newOwner
      this.occupierFieldMemory = this.ownershipChangeForm.dadosForm.newOccupier
    }

    clearOwnershipChange () {
      this.$emit('on-close', {})
    }

    get dateRegisterType () {
      return this.dateRegisterTypeText[this.ownershipChangeDatesForm.dadosForm.dateRegisterType]
    }

    get dateText () {
      const data = this.ownershipChangeDatesForm.dadosForm
      return this.$gettextInterpolate(this.$gettext('DATE_TEXT_OWNERSHIP_CHANGE_CURRENT'), { startDate: data.startDate })
    }

    get partitionElementsInputsSummary () {
      if (this.ownershipChangeSummaryForm.inputs) {
        return this.ownershipChangeSummaryForm.inputs.reduce(function (result, element, i) {
          if (element.model === 'file' || element.model === 'memo') {
            result[0].push(element)
          } else {
            result[1].push(element)
          }
          return result
        }, [[], [], []]
        )
      } else {
        return [[], [], []]
      }
    }

    returnPage () {
      this.pageCount -= 1
    }

    continuePage () {
      const dadosForm = this.ownershipChangeForm.dadosForm
      if (this.pageCount == 0) {
        if (this.ownerFieldMemory === dadosForm.newOwner && this.occupierFieldMemory === dadosForm.newOccupier) {
          messageBox.warn(this.$gettext('NO_CHANGE_OWNERSHIP_CHANGE'))
        } else {
          this.$refs.stepper.next()
        }
      } else if (this.pageCount == 1) {
        if (this.calculateFileAmount(this.listFormFiles) < 1) {
          messageBox.warn(this.$gettext('NO_FILE_OWNERSHIP_CHANGE'))
        } else {
          this.$refs.stepper.next()
        }
      } else if (this.pageCount == 2) {
        if (!this.ownershipChangeDatesForm.dadosForm.startDate) {
          messageBox.warn(this.$gettext('NO_DATA_OWNERSHIP_CHANGE'))
        } else if (this.validateDate()) {
          this.$refs.stepper.next()
        }
      }
    }

    validateDate () {
      const clients = this.splitClients()
      const startDateArray = this.ownershipChangeDatesForm.dadosForm.startDate.toString().split('/')
      const startDate = new Date(parseInt(startDateArray[2]), parseInt(startDateArray[1]) - 1, parseInt(startDateArray[0]))
      const dateCurrent = startDate.getTime()
      const dateRegisterType = this.ownershipChangeDatesForm.dadosForm.dateRegisterType
      if (startDate.getTime() > Date.now()) {
        messageBox.warn(this.$gettext('OWNERSHIP_CHANGE_DATE_CURRENT_AFTER_NOW'))
        return false
      }
      if (this.ownerFieldMemory != this.ownershipChangeForm.dadosForm.newOwner) {
        const clientsOwner = clients[0]
        for (let index = 0; index < clientsOwner.length; index++) {
          const clientStartDate = clientsOwner[index].startDate
          const dateOld = new Date(clientStartDate).getTime()
          if (dateOld === dateCurrent) {
            messageBox.warn(this.$gettext('OWNERSHIP_CHANGE_OVERLAPPING_DATES'))
            return false
          }
          if (clientsOwner[index].available) {
            if (dateRegisterType === 50020001) {
              if (dateCurrent < dateOld) {
                messageBox.warn(this.$gettext('OWNERSHIP_CHANGE_DATE_CURRENT_BEFORE_LATEST'))
                return false
              }
            } else {
              if (dateCurrent > dateOld) {
                messageBox.warn(this.$gettext('OWNERSHIP_CHANGE_DATE_OLD_AFTER_LATEST'))
                return false
              }
            }
          }
        }
      }

      if (this.occupierFieldMemory != this.ownershipChangeForm.dadosForm.newOccupier) {
        const clientsOccupier = clients[1]
        for (let index = 0; index < clientsOccupier.length; index++) {
          const clientStartDate = clientsOccupier[index].startDate
          const dateOld = new Date(clientStartDate).getTime()
          if (dateOld === dateCurrent) {
            messageBox.warn(this.$gettext('OWNERSHIP_CHANGE_OVERLAPPING_DATES'))
            return false
          }
          if (clientsOccupier[index].available) {
            if (dateRegisterType === 50020001) {
              if (dateCurrent < dateOld) {
                messageBox.warn(this.$gettext('OWNERSHIP_CHANGE_DATE_CURRENT_BEFORE_LATEST'))
                return false
              }
            } else {
              if (dateCurrent > dateOld) {
                messageBox.warn(this.$gettext('OWNERSHIP_CHANGE_DATE_OLD_AFTER_LATEST'))
                return false
              }
            }
          }
        }
      }
      return true
    }

    saveOwnershipChange () {
      this.$emit('on-save', { occupierAndOwnerData: this.ownershipChangeForm.dadosForm, filesData: this.listFormFiles, datesData: this.ownershipChangeDatesForm.dadosForm })
    }

    calculateFileAmount (fileArray) {
      let fileAmount = 0
      for (let index = 0; index < fileArray.length; index++) {
        if (fileArray[index].file) {
          fileAmount += 1
        }
      }
      return fileAmount
    }

    addItemFile () {
      this.listFormFiles.push({ file: null, memo: '' })
    }

    dropItemFile (index) {
      this.listFormFiles.splice(index, 1)

      if (this.listFormFiles.length === 0) {
        this.addItemFile()
      }
    }

    async getPerson (idField) {
      const param = { id: idField }
      const { registros } = await repository.resolveDatatableModel(
        'person.pesquisarSelecaoOwnershipChange',
        param
      )
      return registros
    }

    async selections (data) {
      const { newOwner, newOccupier } = this.ownershipChangeForm.dadosForm
      if (data.newOwner?.idField) {
        const registros = await this.getPerson(data.newOwner.idField)
        delete registros[0].id
        delete registros[0].idAcaoGrid
        this.ownershipChangeForm.dadosForm = {
          ...this.ownershipChangeForm.dadosForm,
          newOwnerDocument: registros[0].document,
          newOwnerBirthDate: registros[0].birthDate,
          newOwnerFatherName: registros[0].fatherName,
          newOwnerMotherName: registros[0].motherName,
          newOwnerSpouse: registros[0].spouse,
          newOwnerPhone: registros[0].phone,
          newOwnerAlternativePhone: registros[0].alternativePhone,
          newOwnerEmail: registros[0].email
        }
      } else if (data.newOccupier?.idField) {
        const registros = await this.getPerson(data.newOccupier.idField)
        delete registros[0].id
        delete registros[0].idAcaoGrid
        this.ownershipChangeForm.dadosForm = {
          ...this.ownershipChangeForm.dadosForm,
          newOccupierDocument: registros[0].document,
          newOccupierBirthDate: registros[0].birthDate,
          newOccupierFatherName: registros[0].fatherName,
          newOccupierMotherName: registros[0].motherName,
          newOccupierSpouse: registros[0].spouse,
          newOccupierPhone: registros[0].phone,
          newOccupierAlternativePhone: registros[0].alternativePhone,
          newOccupierEmail: registros[0].email
        }
      } else {
        this.ownershipChangeForm.dadosForm = {
          newOwner, newOccupier
        }
      }
    }
  }
export default JtSearchOwnershipChangeModal
</script>
  <style lang="stylus">

  .jtSearchOwnershipChangeContainer {
    border-radius: 0px !important;
    .q-layout: {
      position: initial !important;
    }
  }

  .jtSearchOwnershipChangeForm {
    #scroll-area {
      height: calc(60vh - 12px) !important;
      .q-scrollarea__content{
        position: relative !important;
      }
    }
  }

  @media only screen and (max-height: 765px) {
    .jtSearchOwnershipChangeForm {
      #scroll-area {
        height: calc(65vh - 12px) !important;
      }
    }
  }

  .jtSearchOwnershipChangeFormSummary {
    #scroll-area {
      height: calc(20vh - 12px) !important;
      .q-scrollarea__content{
        position: relative !important;
      }
    }
  }

  @media only screen and (max-height: 765px) {
    .jtSearchOwnershipChangeFormSummary {
      #scroll-area {
        height: calc(25vh - 12px) !important;
      }
    }
  }

  .jtSearchOwnershipChangeFormSummaryFiles {
    #scroll-area {
      height: calc(15vh - 12px) !important;
      .q-scrollarea__content{
        position: relative !important;
      }
    }
  }

  @media only screen and (max-height: 765px) {
    .jtSearchOwnershipChangeFormSummaryFiles {
      #scroll-area {
        height: calc(20vh - 12px) !important;
      }
    }
  }

  .containerForm-add-ownership {
    height: 13vh !important;
    padding: 25px 25px;
    }

  .cancel-btn {
    background: #A9B9C2 !important;
    color: white;
  }

  </style>
